import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PromoBanner } from '../components/PromoBanner';
import { AboutSection } from '../components/AboutSection';
import { SocialSection } from '../components/SocialSection';
import { ServicesSection } from '../components/ServicesSection';
import { OffersSection } from '../components/OffersSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GallerySection } from '../components/GallerySection';
import { BookingCTA } from '../components/BookingCTA';
export function HomePage() {
  return <>
      <HeroSection data-id="element-501" />
      <PromoBanner data-id="element-502" />
      <AboutSection condensed data-id="element-503" />
      <SocialSection data-id="element-504" />
      <ServicesSection data-id="element-505" />
      <OffersSection data-id="element-506" />
      <TestimonialsSection data-id="element-507" />
      <GallerySection data-id="element-508" />
      <BookingCTA data-id="element-509" />
    </>;
}